import {createSlice} from '@reduxjs/toolkit'
import loadInitialStateObject from './initialStateUtil'

const addressForServiceSlice = createSlice({
    name : "addressForService",
    initialState : loadInitialStateObject('addressForService'),
    reducers : {
        searchAddressStart(state, action) { 
            state.searchStatus = "in-progress"
        },
        searchAddressSuccess(state, action) { 
            state.searchStatus = "success"
        },
        searchAddressError(state, action) { 
            state.searchStatus = "error"
        },
        
    }
})

export const {
    searchAddressStart,
    searchAddressSuccess,
    searchAddressError
} = addressForServiceSlice.actions

export default addressForServiceSlice.reducer
